import { render, staticRenderFns } from "./SystemError.vue?vue&type=template&id=2af54b2a"
import script from "./SystemError.vue?vue&type=script&lang=js"
export * from "./SystemError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports